// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/platform/platform-purchase.tmpl.ts
// Parameters       : infra/fleet/registry/repos.ts  (entry "malla-vpn-app")
// Destination      : apps/web/src/lib/platform.ts
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo malla-vpn-app
//     node fleet/fleet.ts check --repo malla-vpn-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { currentPurchasePlatformFor, type ResolvedPurchasePlatform } from "@malla/shared";

/**
 * Runtime platform detection.
 *
 * True when the page is being served inside a Tauri WebView. Mirrors what
 * `@tauri-apps/api/core`'s `isTauri()` checks — we read the global directly
 * to avoid having to load the Tauri JS module just for a feature flag.
 */
export function isTauriRuntime(): boolean {
  return "__TAURI_INTERNALS__" in globalThis;
}

/**
 * PURCHASE surface this copy of the app is running on.
 *
 * Lives here and not in `shared` because native-runtime detection belongs to the
 * app (`__TAURI_INTERNALS__`); the classification —and everything decided from
 * it— belongs to the kit (`monetization/purchase.ts`). Having a single place call
 * it means there's no second way to answer "are we in the APK?".
 *
 * The nuance most often gotten wrong: Chrome on an Android phone returns `web`, not
 * `android`. Play's billing policy applies to the binary, not to mobile web.
 */
export function currentPurchasePlatform(): ResolvedPurchasePlatform {
  return currentPurchasePlatformFor(isTauriRuntime());
}
